const categories = [
    {
        name: 'Danger',
        value: 'bg-danger'
    },
    {
        name: 'Success',
        value: 'bg-success'
    },
    {
        name: 'Primary',
        value: 'bg-primary'
    },
    {
        name: 'Info',
        value: 'bg-info'
    },
    {
        name: 'Dark',
        value: 'bg-dark'
    },
    {
        name: 'Warning',
        value: 'bg-warning'
    },
];

const calendarEvents = [
    {
        id: 1,
        title: 'Natalia Górniak',
        start: new Date(2023,2,1,12,0,0,0),
        className: 'bg-warning text-white',
    },
      {
        id: 2,
        title: 'Aleksandra Kemnitz',
        start: new Date(2023,2,1,8,0,0,0),
        className: 'bg-success text-white',
    },
    {
        id: 3,
        title: 'Natalia Górniak',
        start: new Date(2023,2,2,12,0,0,0),
        className: 'bg-warning text-white',
    },
    {
        id: 4,
        title: 'Aleksandra Kemnitz',
        start: new Date(2023,2,2,8,0,0,0),
        className: 'bg-success text-white',
    },
    {
        id: 5,
        title: 'Natalia Górniak',
        start: new Date(2023,2,3,12,0,0,0),
        className: 'bg-warning text-white',
    },
    {
        id: 6,
        title: 'Aleksandra Kemnitz',
        start: new Date(2023,2,3,8,0,0,0),
        className: 'bg-success text-white',
    },
  {
        id: 7,
        title: 'Natalia Górniak',
        start: new Date(2023,2,4,12,0,0,0),
        className: 'bg-warning text-white',
    },
    {
        id: 8,
        title: 'Aleksandra Kemnitz',
        start: new Date(2023,2,4,8,0,0,0),
        className: 'bg-success text-white',
    },
  {
        id: 9,
        title: 'Natalia Górniak',
        start: new Date(2023,2,6,12,0,0,0),
        className: 'bg-warning text-white',
    },
    {
        id: 10,
        title: 'Aleksandra Kemnitz',
        start: new Date(2023,2,6,8,0,0,0),
        className: 'bg-success text-white',
    },
  {
        id: 11,
        title: 'Natalia Górniak',
        start: new Date(2023,2,7,12,0,0,0),
        className: 'bg-warning text-white',
    },
    {
        id: 12,
        title: 'Aleksandra Kemnitz',
        start: new Date(2023,2,7,8,0,0,0),
        className: 'bg-success text-white',
    },
  {
        id: 13,
        title: 'Natalia Górniak',
        start: new Date(2023,2,8,12,0,0,0),
        className: 'bg-warning text-white',
    },
    {
        id: 14,
        title: 'Aleksandra Kemnitz',
        start: new Date(2023,2,8,8,0,0,0),
        className: 'bg-success text-white',
    },
  {
        id: 17,
        title: 'Natalia Górniak',
        start: new Date(2023,2,9,12,0,0,0),
        className: 'bg-warning text-white',
    },
    {
        id: 16,
        title: 'Aleksandra Kemnitz',
        start: new Date(2023,2,9,8,0,0,0),
        className: 'bg-success text-white',
    },
  {
        id: 17,
        title: 'Natalia Górniak',
        start: new Date(2023,2,10,12,0,0,0),
        className: 'bg-warning text-white',
    },
    {
        id: 18,
        title: 'Aleksandra Kemnitz',
        start: new Date(2023,2,10,8,0,0,0),
        className: 'bg-success text-white',
    },
  {
        id: 19,
        title: 'Natalia Górniak',
        start: new Date(2023,2,11,12,0,0,0),
        className: 'bg-warning text-white',
    },
    {
        id: 20,
        title: 'Aleksandra Kemnitz',
        start: new Date(2023,2,11,8,0,0,0),
        className: 'bg-success text-white',
    },
  {
        id: 21,
        title: 'Natalia Górniak',
        start: new Date(2023,2,13,12,0,0,0),
        className: 'bg-warning text-white',
    },
    {
        id: 22,
        title: 'Aleksandra Kemnitz',
        start: new Date(2023,2,13,8,0,0,0),
        className: 'bg-success text-white',
    },
  {
        id: 23,
        title: 'Natalia Górniak',
        start: new Date(2023,2,14,12,0,0,0),
        className: 'bg-warning text-white',
    },
    {
        id: 24,
        title: 'Aleksandra Kemnitz',
        start: new Date(2023,2,14,8,0,0,0),
        className: 'bg-success text-white',
    },
  {
        id: 25,
        title: 'Natalia Górniak',
        start: new Date(2023,2,15,12,0,0,0),
        className: 'bg-warning text-white',
    },
    {
        id: 26,
        title: 'Aleksandra Kemnitz',
        start: new Date(2023,2,15,8,0,0,0),
        className: 'bg-success text-white',
    },
  {
        id: 27,
        title: 'Natalia Górniak',
        start: new Date(2023,2,16,12,0,0,0),
        className: 'bg-warning text-white',
    },
    {
        id: 28,
        title: 'Aleksandra Kemnitz',
        start: new Date(2023,2,16,8,0,0,0),
        className: 'bg-success text-white',
    },
  {
        id: 29,
        title: 'Natalia Górniak',
        start: new Date(2023,2,17,12,0,0,0),
        className: 'bg-warning text-white',
    },
    {
        id: 30,
        title: 'Aleksandra Kemnitz',
        start: new Date(2023,2,17,8,0,0,0),
        className: 'bg-success text-white',
    },
  {
        id: 31,
        title: 'Natalia Górniak',
        start: new Date(2023,2,18,12,0,0,0),
        className: 'bg-warning text-white',
    },
  {
        id: 32,
        title: 'Natalia Górniak',
        start: new Date(2023,2,18,12,0,0,0),
        className: 'bg-warning text-white',
    },
    {
        id: 33,
        title: 'Aleksandra Kemnitz',
        start: new Date(2023,2,20,8,0,0,0),
        className: 'bg-success text-white',
    },
  {
        id: 34,
        title: 'Natalia Górniak',
        start: new Date(2023,2,20,12,0,0,0),
        className: 'bg-warning text-white',
    },
    {
        id: 35,
        title: 'Aleksandra Kemnitz',
        start: new Date(2023,2,21,8,0,0,0),
        className: 'bg-success text-white',
    },
  {
        id: 36,
        title: 'Natalia Górniak',
        start: new Date(2023,2,21,12,0,0,0),
        className: 'bg-warning text-white',
    },

];

export { categories, calendarEvents };
